/**
 * Best-effort filter for noisy third-party logs (e.g. embed analytics) so they do not
 * appear in the top-level console. Does not affect the Network tab or DevTools for child frames.
 */
const PATTERNS = [/trupeer\.ai/i, /app\.trupeer/i];

function shouldSuppress(args: unknown[]): boolean {
  try {
    const text = args.map((a) => (typeof a === 'string' ? a : JSON.stringify(a))).join(' ');
    return PATTERNS.some((p) => p.test(text));
  } catch {
    return false;
  }
}

function wrap(key: 'error' | 'warn' | 'log' | 'info' | 'debug'): void {
  const orig = console[key].bind(console) as (...args: unknown[]) => void;
  (console as unknown as Record<string, (...args: unknown[]) => void>)[key] = (...args: unknown[]) => {
    if (shouldSuppress(args)) return;
    orig(...args);
  };
}

wrap('error');
wrap('warn');
wrap('log');
wrap('info');
wrap('debug');
